export default class AbnormalSpaceValue {
    public constructor(
        public spaceName: string,
        public occupancyPercentage: number) {
    }
}